module.exports = "/_next/static/images/ChatbotsDoughnut-2dc07c1b3604903053952982e4201f38.webp";